// typings

import { create } from "zustand";
import { persist } from "zustand/middleware";

import { IModeloClienteState } from "@/store-zustand/cliente/details-modelo/index.d";

// criação da store com Zustand (Fixas Tecnicas)
export const useStoreZustandModelosCliente = create<IModeloClienteState>()(
  persist(
    (set) => ({
      // estados
      isLoading: false,
      isModalSolicitacaoRemessa: false,
      paginations: [1],
      itemsPerPage: 5,
      currentPage: 1,
      totalItemsPage: 0,
      searchItem: "",
      lastPage: 0,
      modeloUnico: null,
      dadosResponsabilidade: null,
      selectedFile: null,
      selectedZipFile: null,
      dadosRemessa: [],

      // ações
      setIsLoading: (isLoading) => set({ isLoading }),
      setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),
      setCurrentPage: (currentPage) => set({ currentPage }),
      setTotalItemsPage: (totalItemsPage) => set({ totalItemsPage }),
      setSearchItem: (searchItem) => set({ searchItem }),
      setLastPage: (lastPage) => set({ lastPage }),
      setPaginations: (paginations) => set({ paginations }),
      setModeloUnico: (modeloUnico) => set({ modeloUnico }),
      setDadosRemessa: (dadosRemessa) => set({ dadosRemessa }),
      setisModalSolicitacaoRemessa: (isModalSolicitacaoRemessa) =>
        set({ isModalSolicitacaoRemessa }),
      setDadosResponsabilidade: (dados) => set({ dadosResponsabilidade: dados }),

      setSelectedZipFile: (file) => set({ selectedZipFile: file }),
      setSelectedFile: (file) => set({ selectedFile: file }),

      setCleanStateData: () => {
        set(() => {
          return {
            modeloUnico: null,
            dadosRemessa: [],
          };
        });
      },
      clearPersistedData: () =>
        set({
          modeloUnico: null,
          dadosRemessa: [],
        }),
    }),
    {
      name: "store-modelo-unico",
      partialize: (state) => ({
        modeloUnico: state.modeloUnico,
      }),
    }
  )
);
